export enum GradingMethod {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}
export enum GradingPreference {
  AFTER_EACH_QUESTION = 'AFTER_EACH_QUESTION',
  AFTER_ALL_QUESTIONS = 'AFTER_ALL_QUESTIONS',
}
